import { mergeDeepRight } from 'ramda';

type LocalStorageState = {
  employeePortal?: {
    teamRoster?: {
      lastSelectedPlanUnitsIds?: (string | number)[] | null;
      employees?: {
        showOnlyPlanned?: boolean;
      };
      duties?: {
        isGroupedByPlanUnit?: boolean;
        isGroupedByFunction?: boolean;
      };
    };
  };
};

export const getLocalState = (): LocalStorageState =>
  JSON.parse(localStorage.getItem('appState') || '{}');

export const updateLocalState = (partialState: LocalStorageState) => {
  const existingState = getLocalState();
  const mergedState = mergeDeepRight(existingState, partialState);
  localStorage.setItem('appState', JSON.stringify(mergedState));
};
